import { IAttrValue } from "@multiweb/types/contracts";
import { ITextBuilder } from "../../../../../../../Global/Base/Builders/ITextBuilder";
import { ItemTemplate } from "../../../../../../UI.Controls/DataGridSubcontrols/Templates/ItemTemplate";
import { FileCellElement } from "../Cells/FileCellElement";
/**
* Template pro needitovatelný FileEdit
*/
export class FileTemplate extends ItemTemplate {
    public override async updateData(dataSet: IAttrValue[], item: HTMLElement): Promise<void> {
        const value = await this._getJoinData(dataSet, this.parentColumn);
        (item as FileCellElement).fileName = value;
    }

    protected override _createContentElement(): HTMLElement {
        const cell = new FileCellElement();
        cell.initialize(this.parentColumn);
        return cell as HTMLElement;
    }

    public override updateDisplayedData(data: ITextBuilder, item: HTMLElement): void {
        (item as FileCellElement).fileName = data.toString();
    }
}
